export enum AggregatedGoodsCategory {
  // Aluminium
  'UNWROUGHT_ALUMINIUM' = 'UNWROUGHT_ALUMINIUM',
  'ALUMINIUM_PRODUCTS' = 'ALUMINIUM_PRODUCTS',
  // Cement
  'CALCINED_CLAY' = 'CALCINED_CLAY',
  'CEMENT_CLINKER' = 'CEMENT_CLINKER',
  'CEMENT' = 'CEMENT',
  'ALUMINOUS_CEMENT' = 'ALUMINOUS_CEMENT',
  // Fertilizers
  'NITRIC_ACID' = 'NITRIC_ACID',
  'AMMONIA' = 'AMMONIA',
  'MIXED_FERTILIZERS' = 'MIXED_FERTILIZERS',
  'UREA' = 'UREA',

  // Iron and Steel
  'SINTERED_ORE' = 'SINTERED_ORE',
  'PIG_IRON' = 'PIG_IRON',
  'FE_MN' = 'FE_MN',
  'FE_CR' = 'FE_CR',
  'FE_NI' = 'FE_NI',
  'DIRECT_REDUCED_IRON' = 'DIRECT_REDUCED_IRON',
  'IRON_OR_STEEL_PRODUCTS' = 'IRON_OR_STEEL_PRODUCTS',
  'CRUDE_STEEL' = 'CRUDE_STEEL',
  // Electricity
  'ELECTRICITY' = 'ELECTRICITY',
  // Hydrogen
  'HYDROGEN' = 'HYDROGEN'
}

export enum ProductionMethods {
  CalcinedClay = 'P01',
  CementClinker = 'P02',
  Cement = 'P03',
  AluminousCement = 'P04',
  SinteredOre = 'P05',
  Electricity = 'P08',
  SteamReforming = 'P09',
  PartialOxidation = 'P10',
  OtherFuelBasedHydrogenProduction = 'P11',
  ElectrolysisOfWater = 'P12',
  ElectrolysisOfWaterOtherEnergySources = 'P13',
  ChlorAlkaliElectrolysis = 'P14',
  ProductionOfChlorates = 'P15',
  OtherProductionRoutes = 'P16',
  NitricAcid = 'P17',
  HaberBoschProcessWithSteamReformingOfNaturalGasOrBiogas = 'P19',
  HaberBoschProcessWithGasificationOfCoalOrOtherFuels = 'P20',
  OtherProductionRoutes2 = 'P21',
  MixedFertilisers = 'P22',
  Urea = 'P23',
  BlastFurnaceRoute = 'P24',
  SmeltingReduction = 'P25',
  OtherProductionRoutes3 = 'P26',
  NickelPigIronProduction = 'P27',
  NickelPigIronProduction2 = 'P28',
  FerroNickel = 'P29',
  FerroChromium = 'P30',
  FerroManganese = 'P31',
  ProductionOfDirectReducedIronUsingHydrogen = 'P32',
  DirectReducedIron = 'P33',
  IronOrSteelProducts = 'P34',
  BasicOxigenSteelMaking = 'P35',
  BasicOxigenSteelMakingInclBlastFurnace = 'P36',
  BasicOxigenSteelMakingInclMeltingReduction = 'P37',
  ElectricArcFurnace = 'P38',
  ElectricArcFurnaceAlloySteels = 'P39',
  ElectricArcFurnaceCarbonSteelFromDirectReducedIron = 'P40',
  ElectricArcFurnaceGeneral = 'P41',
  PrimaryElectrolyticSmelting = 'P42',
  SecondaryMeltingRecycling = 'P43',
  MixOfPrimaryAndSecondaryProduction = 'P44',
  AluminiumProducts = 'P45',
  IntegratedProductionWithPrimarySmelting = 'P46',
  IntegratedProductionWithSecondaryMelting = 'P47',
  IntegratedWithMixedPrimaryAndSecondaryProduction = 'P48'
}

export const productionMethods = [
  {
    code: ProductionMethods.PrimaryElectrolyticSmelting,
    aggregatedGoodsCategory: AggregatedGoodsCategory.UNWROUGHT_ALUMINIUM,
    name: 'Primary (electrolytic) smelting',
    precursorAggGoodCategory: [],
    cbamBenchmark: 1.464,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.SecondaryMeltingRecycling,
    aggregatedGoodsCategory: AggregatedGoodsCategory.UNWROUGHT_ALUMINIUM,
    name: 'Secondary smelting (recycling)',
    precursorAggGoodCategory: [AggregatedGoodsCategory.UNWROUGHT_ALUMINIUM],
    cbamBenchmark: 0.3,
    isPrecursorRequired: false
  },
  {
    aggregatedGoodsCategory: AggregatedGoodsCategory.ALUMINIUM_PRODUCTS,
    precursorAggGoodCategory: [AggregatedGoodsCategory.UNWROUGHT_ALUMINIUM],
    code: ProductionMethods.AluminiumProducts,
    name: 'Aluminium products',
    cbamBenchmark: 1.464,
    isApplicableForActivityLevelValidation: true,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.CalcinedClay, // P01
    aggregatedGoodsCategory: AggregatedGoodsCategory.CALCINED_CLAY,
    name: 'Cement',
    precursorAggGoodCategory: [],
    cbamBenchmark: 0.973,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.CementClinker, // P02
    aggregatedGoodsCategory: AggregatedGoodsCategory.CEMENT_CLINKER,
    name: 'Cement clinker',
    precursorAggGoodCategory: [],
    cbamBenchmark: 0.973,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.Cement, // P03
    aggregatedGoodsCategory: AggregatedGoodsCategory.CEMENT,
    name: 'Cement clinker',
    precursorAggGoodCategory: [],
    cbamBenchmark: 0.973,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.AluminousCement, // P04
    aggregatedGoodsCategory: AggregatedGoodsCategory.ALUMINOUS_CEMENT,
    name: 'Aluminous cement',
    precursorAggGoodCategory: [],
    cbamBenchmark: 0.973,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.SinteredOre,
    aggregatedGoodsCategory: AggregatedGoodsCategory.SINTERED_ORE,
    name: 'Sintered ore',
    precursorAggGoodCategory: [],
    cbamBenchmark: 0.163,
    usesMassBalance: true,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.FerroManganese,
    aggregatedGoodsCategory: AggregatedGoodsCategory.FE_MN,
    name: 'Ferro manganese',
    precursorAggGoodCategory: [],
    cbamBenchmark: 0,
    usesMassBalance: true,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.FerroNickel,
    aggregatedGoodsCategory: AggregatedGoodsCategory.FE_NI,
    name: 'Ferro nickel',
    precursorAggGoodCategory: [],
    cbamBenchmark: 0,
    usesMassBalance: true,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.FerroChromium,
    aggregatedGoodsCategory: AggregatedGoodsCategory.FE_CR,
    name: 'Ferro chromium',
    precursorAggGoodCategory: [],
    cbamBenchmark: 0,
    usesMassBalance: true,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.DirectReducedIron,
    aggregatedGoodsCategory: AggregatedGoodsCategory.DIRECT_REDUCED_IRON,
    name: 'Direct reduced iron',
    precursorAggGoodCategory: [],
    usesMassBalance: true,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.ProductionOfDirectReducedIronUsingHydrogen,
    aggregatedGoodsCategory: AggregatedGoodsCategory.DIRECT_REDUCED_IRON,
    name: 'Production of direct reduced iron using hydrogen',
    precursorAggGoodCategory: [],
    cbamBenchmark: 0.205,
    usesMassBalance: true,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.BasicOxigenSteelMaking,
    aggregatedGoodsCategory: AggregatedGoodsCategory.CRUDE_STEEL,
    name: 'Basic oxigen steel making',
    precursorAggGoodCategory: [],
    cbamBenchmark: 0.47,
    usesMassBalance: true,
    isPrecursorRequired: true
  },
  // {
  //   code: ProductionMethods.BasicOxigenSteelMakingInclBlastFurnace,
  //   aggregatedGoodsCategory: AggregatedGoodsCategory.CRUDE_STEEL,
  //   name: "Basic oxigen steel making incl blast furnace",
  //   precursorAggGoodCategory: [],
  //   usesMassBalance: true,
  // },
  // {
  //   code: ProductionMethods.BasicOxigenSteelMakingInclMeltingReduction,
  //   aggregatedGoodsCategory: AggregatedGoodsCategory.CRUDE_STEEL,
  //   name: "Basic oxigen steel making incl melting reduction",
  //   precursorAggGoodCategory: [],
  //   usesMassBalance: true,
  // },
  {
    code: ProductionMethods.ElectricArcFurnace,
    aggregatedGoodsCategory: AggregatedGoodsCategory.CRUDE_STEEL,
    name: 'Electric arc furnace',
    precursorAggGoodCategory: [],
    cbamBenchmark: 0.215,
    usesMassBalance: true,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.BlastFurnaceRoute,
    aggregatedGoodsCategory: AggregatedGoodsCategory.PIG_IRON,
    name: 'Blast furnace route',
    precursorAggGoodCategory: [],
    usesMassBalance: true,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.SmeltingReduction,
    aggregatedGoodsCategory: AggregatedGoodsCategory.PIG_IRON,
    name: 'Smelting reduction',
    precursorAggGoodCategory: [],
    usesMassBalance: true,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.IronOrSteelProducts,
    aggregatedGoodsCategory: AggregatedGoodsCategory.IRON_OR_STEEL_PRODUCTS,
    name: 'Iron or steel products',
    precursorAggGoodCategory: [
      AggregatedGoodsCategory.IRON_OR_STEEL_PRODUCTS,
      AggregatedGoodsCategory.CRUDE_STEEL,
      AggregatedGoodsCategory.PIG_IRON,
      AggregatedGoodsCategory.FE_MN,
      AggregatedGoodsCategory.FE_NI,
      AggregatedGoodsCategory.FE_CR
    ],
    cbamBenchmark: 0.47,
    isApplicableForActivityLevelValidation: true,
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.NitricAcid, // P17
    aggregatedGoodsCategory: AggregatedGoodsCategory.NITRIC_ACID,
    name: 'Nitric acid',
    precursorAggGoodCategory: [],
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.HaberBoschProcessWithSteamReformingOfNaturalGasOrBiogas, // P19
    aggregatedGoodsCategory: AggregatedGoodsCategory.AMMONIA,
    name: 'Haber-Bosch process with steam reforming of natural gas or biogas',
    precursorAggGoodCategory: [],
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.HaberBoschProcessWithGasificationOfCoalOrOtherFuels, // P20
    aggregatedGoodsCategory: AggregatedGoodsCategory.AMMONIA,
    name: 'Haber-Bosch process with gasification of coal or other fuels',
    precursorAggGoodCategory: [],
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.OtherProductionRoutes2, // P21
    aggregatedGoodsCategory: AggregatedGoodsCategory.AMMONIA,
    name: 'Other production routes',
    precursorAggGoodCategory: [],
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.MixedFertilisers, // P22
    aggregatedGoodsCategory: AggregatedGoodsCategory.MIXED_FERTILIZERS,
    name: 'Mixed fertilisers',
    precursorAggGoodCategory: [],
    isPrecursorRequired: true
  },
  {
    code: ProductionMethods.Urea, // P23
    aggregatedGoodsCategory: AggregatedGoodsCategory.UREA,
    name: 'Urea',
    precursorAggGoodCategory: [],
    isPrecursorRequired: true
  }
]

export const productionMethodsByCode = productionMethods.reduce(
  (acc, productionMethod) => {
    acc[productionMethod.code] = productionMethod
    return acc
  },
  {} as Record<string, (typeof productionMethods)[number]>
)

export const getBenchmarkProductionMethod = (productionMethodCode?: string) => {
  const productionMethod = productionMethodCode
    ? productionMethodsByCode[productionMethodCode as ProductionMethods]
    : null

  if (!productionMethod) {
    return {
      cbamBenchmark: 0,
      productionMethodFound: false,
      benchMarkFound: false
    }
  }

  if (!productionMethod.cbamBenchmark) {
    return {
      cbamBenchmark: 0,
      productionMethodFound: true,
      benchMarkFound: false
    }
  }

  return {
    cbamBenchmark: productionMethod.cbamBenchmark,
    productionMethodFound: true,
    benchMarkFound: true
  }
}

export const isProductionMethodAluminium = (productionMethodCode?: string) => {
  const aluminiumAggGoodCategories = [
    AggregatedGoodsCategory.UNWROUGHT_ALUMINIUM,
    AggregatedGoodsCategory.ALUMINIUM_PRODUCTS
  ]
  return aluminiumAggGoodCategories.includes(
    productionMethodsByCode[productionMethodCode as ProductionMethods].aggregatedGoodsCategory
  )
}

export const isProductionMethodIronAndSteel = (productionMethodCode?: string) => {
  const ironAndSteelAggGoodCategories = [
    AggregatedGoodsCategory.IRON_OR_STEEL_PRODUCTS,
    AggregatedGoodsCategory.CRUDE_STEEL,
    AggregatedGoodsCategory.PIG_IRON,
    AggregatedGoodsCategory.SINTERED_ORE,
    AggregatedGoodsCategory.FE_MN,
    AggregatedGoodsCategory.FE_NI,
    AggregatedGoodsCategory.FE_CR,
    AggregatedGoodsCategory.DIRECT_REDUCED_IRON
  ]
  return ironAndSteelAggGoodCategories.includes(
    productionMethodsByCode[productionMethodCode as ProductionMethods].aggregatedGoodsCategory
  )
}
